module.exports = __webpack_public_path__ + "img/user-avatar-3.0af65768.png";